<template>
    <div :class="formGroupModifiers" class="c-form-group">
        <div @click="focus" class="vc-base-stripe-control c-control">
            <stripe-element
                    :class="controlInputModifiers"
                    :id="id"
                    :options="options"
                    :stripe="stripe"
                    :type="type"
                    :value="value"
                    @blur="onBlur"
                    @change="onChange"
                    @focus="onFocus"
                    class="vc-base-stripe-control__input c-control__input"
                    ref="element"
            />
            <label :for="id" class="c-control__label">{{label}}</label>
            <input :name="name" :value="extractedValue" type="hidden" v-if="type === 'postalCode'">
        </div>
        <div class="c-control-footer c-control-footer--error" v-if="error">
            {{error.message}}
        </div>
        <div class="c-control-footer c-control-footer--error" v-else-if="shouldNotBeEmpty">
            Please enter the {{label}}.
        </div>
    </div>
</template>

<script>
    import Styles from '../../mixins/styles.vue'
    import VueStripe from '../../vendor/vue-stripe-elements'

    export default {
        name: "base-stripe-control",
        props: {
            id: {
                type: String,
                required: true,
            },
            stripe: {
                type: [String, Object],
                required: true
            },
            type: {
                type: String,
                required: true,
                validator: function (value) {
                    return ['cardNumber', 'cardCvc', 'cardExpiry', 'postalCode'].indexOf(value) !== -1;
                }
            },
            value: {
                type: String,
                required: false
            },
            label: {
                type: String,
                required: true,
            },
            name: {
                type: String,
            },
            triggerValidation: {
                type: Boolean,
                default: false,
            }
        },
        mixins: [Styles],
        components: {
            StripeElement: VueStripe.StripeElement
        },
        data() {
            return {
                activated: false,
                active: false,
                tempActive: false,
                complete: false,
                empty: true,
                error: null,
                options: null,
                validated: false,
                extractedValue: null
            }
        },
        created() {
            this.options = {
                elements: {
                    fonts: [
                        {
                            cssSrc: 'https://fonts.googleapis.com/css?family=Poppins:400,500'
                        }
                    ]
                },
                style: {
                    base: {
                        color: this.style['--input-text-color'],
                        fontSmoothing: 'antialiased',
                        fontSize: '14px',
                        fontFamily: 'Poppins',
                        fontWeight: '500',
                        '::placeholder': {
                            color: 'rgba(0,0,0,0)',
                        },
                    },
                    invalid: {
                        color: this.style['--input-text-color'],
                    }
                }
            };
        },
        computed: {
            controlInputModifiers() {
                return {
                    'c-control__input--active': this.active,
                    'c-control__input--filled': !this.empty,
                    'c-control__input--blur': !this.active,
                }
            },
            formGroupModifiers() {
                return {
                    'c-form-group--error': this.hasError,
                };
            },
            hasError() {
                return this.error || this.shouldNotBeEmpty;
            },
            shouldNotBeEmpty() {
                return this.empty && !this.active && (this.activated || this.triggerValidation);
            },
        },
        methods: {
            blur() {
                this.$refs.element.blur();
            },
            clear() {
                this.$refs.element.clear();
            },
            focus() {
                this.$refs.element.focus();
            },
            onFocus() {
                this.tempActive = true;
                setTimeout(() => {
                    if (this.tempActive) {
                        this.active = true;
                    }
                }, 100);
                this.active = true;
            },
            onBlur() {
                this.tempActive = false;
                setTimeout(() => {
                    if (!this.tempActive) {
                        this.activated = true;
                        this.active = false;
                    }
                }, 100);
                this.$emit('blur');
            },
            onChange(event) {
                this.complete = event.complete;
                this.empty = event.empty;
                this.error = event.error;
                this.validated = !this.error && this.complete;
                this.extractedValue = event.value;

                this.$emit('validated', this.validated);
                this.$emit('change', event);

                if (this.type === 'postalCode')
                    this.$emit('input', this.extractedValue);
            }
        }

    }
</script>

<style lang="scss" scoped>
    .vc-base-stripe-control__input {
        padding-top: 22px;
    }
</style>